module.exports = __webpack_public_path__ + "static/utenos-912f9d9bbaa7b8c5f8a15c95b0c094a9.png";